<template>
  <li>
    <router-link :to="to" class="menu-item">
      <img
        :src="item.icon"
        :style="item.menu === 'printer' && 'width:32px !important'"
        class="icon"
      />
      <img
        :src="item.iconHover"
        :style="item.menu === 'printer' && 'width:32px !important'"
        class="icon-hover"
      />
      {{ lang === "en" ? item.titleEn : item.titleEs }}
    </router-link>
    <ul class="children" v-if="item.children">
      <li class="child-heading">
        {{ lang === "en" ? item.titleEn : item.titleEs }}
      </li>
      <template v-for="(child, key) in item.children">
        <li v-if="isRoleMatch(child)" :key="key">
          <router-link :to="child.to" exact>
            {{ lang === "en" ? child.titleEn : child.titleEs }}
          </router-link>
        </li>
      </template>
    </ul>
  </li>
</template>
<script>
export default {
  name: "web-menu-item",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    to() {
      return this.item.to || this.item.children[0].to;
    },
    lang() {
      return this.$i18n.locale;
    },
    role() {
      return this.$store.state.user.role;
    },
  },
  methods: {
    isRoleMatch(item) {
      return item.roles ? item.roles.includes(this.role) : true;
    },
  },
};
</script>
